import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './LivePayouts.css';
import { Carousel, Layout, notification } from 'antd';
import Clock from '../Clock/Clock';
import Slide from '../Slide/Slide';
import BanksPayouts from '../BanksPayouts/BanksPayouts';
import CountryStatistics from '../CountryStatistics/CountryStatistics';
import { useSignalR } from '../../helpers/signalR';
import { LivePayoutsContext } from '../../contexts/LivePayoutsContext';
import { useLivePayoutsApi } from '../../hooks/useLivePayoutsApi';
import { Country, getCountry } from '../../model/Country';
import ProductStatistics from '../ProductStatistics/ProductStatistics';
import { ProductType } from 'motty-utils';
import { getAccessToken } from '../../helpers/getAccessToken';
import { useMsal } from '@azure/msal-react';
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import dayjs from "dayjs";
import { renderPayoutNotification } from "../../helpers/renderPayoutNotification";
import { useForceUpdate } from 'antd/es/_util/hooks';
const { Header, Content } = Layout;
const LivePayouts = () => {
    const [, forceUpdate] = useForceUpdate();
    const msal = useMsal();
    const getToken = () => getAccessToken(msal);
    const api = useLivePayoutsApi(getToken);
    const [notifications, notificationContext] = notification.useNotification({
        duration: 60,
        placement: 'bottomRight',
        maxCount: 2
    });
    const slidingSpeed = parseFloat((new URL(window.location.href)).searchParams.get('speed') || '20');
    const [livePayouts, setLivePayouts] = useState();
    let country = getCountry();
    useEffect(() => {
        api.getLivePayouts(dayjs().startOf('month').toDate()).then(res => {
            setLivePayouts(res.data);
            startSignalR();
            const now = dayjs();
            const reloadAt = now.add(1, 'day').startOf('day');
            const reloadIn = reloadAt.diff(now);
            setTimeout(() => {
                document.location.reload();
            }, reloadIn);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const onNewPayout = (payout) => {
        setLivePayouts(prev => [...(prev || []), payout]);
        notifications.success(Object.assign({ closeIcon: false }, renderPayoutNotification(payout)));
    };
    const startSignalR = useSignalR(getToken, onNewPayout);
    return (_jsxs(LivePayoutsContext.Provider, { value: livePayouts, children: [notificationContext, _jsxs(Layout, { style: { height: '100%' }, className: livePayouts ? 'loaded' : '', children: [_jsx(LoadingScreen, {}), _jsx(Header, { children: _jsx(Clock, {}) }), _jsx(Content, { children: _jsxs(Carousel, { autoplay: true, dots: true, autoplaySpeed: slidingSpeed * 1000, beforeChange: forceUpdate, children: [(country === Country.Norge) &&
                                    _jsx(Slide, { country: country, title: "Motty Norge", children: _jsx(CountryStatistics, { country: country }) }), (country === Country.Polska) &&
                                    _jsx(Slide, { country: country, title: "Motty Polska", children: _jsx(CountryStatistics, { country: country }) }), _jsx(Slide, { country: country, title: "Consumer Loan", children: _jsx(ProductStatistics, { product: ProductType.ConsumerLoan }) }), _jsx(Slide, { country: country, title: "Credit Card", children: _jsx(ProductStatistics, { product: ProductType.CreditCard }) }), _jsx(Slide, { country: country, title: "Mortgage", children: _jsx(ProductStatistics, { product: ProductType.Mortgage }) }), _jsx(Slide, { country: country, title: "Bank Payouts", children: _jsx(BanksPayouts, {}) })] }) })] })] }));
};
export default LivePayouts;
